import { boot } from 'quasar/wrappers'
import isInvalidNumericString from '../functions/is-invalid-numstring'

export default boot(({ app }) => {
	app.config.globalProperties.$isInvalidNumericString = isInvalidNumericString
})
